import { render, staticRenderFns } from "./batch-edit-delivery-date-modal.vue?vue&type=template&id=4db3bc34&scoped=true"
import script from "./batch-edit-delivery-date-modal.vue?vue&type=script&lang=js"
export * from "./batch-edit-delivery-date-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db3bc34",
  null
  
)

export default component.exports